import SectionHeading from "@/pages/home/components/SectionHeading";
import { testimonialItems } from "@/mocks/digData";

const principles = [
  {
    id: "p-1",
    icon: "ri-time-line",
    title: "先对齐时间，再谈观点",
    text: "每条更新都挂上时间与来源类型，让因果顺序清楚，避免用过期片段当最新进展。",
  },
  {
    id: "p-2",
    icon: "ri-scales-3-line",
    title: "说法并列，不替任何一方定性",
    text: "冲突口径同时保留，并标明「待补充」；结论未定之前，不用判断性词汇代替事实。",
  },
  {
    id: "p-3",
    icon: "ri-error-warning-line",
    title: "错了就标更正，不悄悄改",
    text: "早期叙述若有调整，会在原条目加「已更正」并说明原因，保留完整脉络供你回看。",
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="scroll-mt-24 py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
          <div>
            <SectionHeading
              eyebrow="ABOUT US"
              title="关于瓜田速报"
              desc="我们是一群习惯把一件事追到底的人。比起抢第一句结论，更在意把前后脉络拼完整——让吃瓜这件事也能吃得明白。"
            />
            <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed">
              瓜田速报定位为<strong className="text-foreground-900">网爆吃瓜连续剧追踪站</strong>，
              专注跟进网络热议事件的后续反转与最新进展。我们把同一事件的碎片信息聚合成剧情线，
              标清当事人发声与官方回应，并如实记录每一次口径变化。
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              网站坚持「快速但不抢跑」：热点来得快，我们先核对再同步；信息不完整时，宁可标注待补充，
              也不把猜测写进正文。这是我们对每一位追更用户的承诺。
            </p>
            <a
              href="#contact"
              className="mt-8 inline-flex items-center gap-2 px-5 py-3 rounded-md bg-primary-500 text-background-50 font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-mail-send-line" />
              联系编辑部
            </a>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-7">
            <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">
              我们的三条内容原则
            </h3>
            <ul className="mt-5 flex flex-col gap-5">
              {principles.map((item) => (
                <li key={item.id} className="flex gap-4">
                  <span className="shrink-0 w-11 h-11 flex items-center justify-center rounded-full bg-primary-500/10">
                    <i className={`${item.icon} text-xl text-primary-600`} />
                  </span>
                  <div>
                    <p className="font-heading font-bold text-foreground-950">{item.title}</p>
                    <p className="mt-1 text-sm text-foreground-600 leading-relaxed">{item.text}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 md:mt-20">
          <h3 className="font-heading text-xl md:text-2xl font-black text-foreground-950">
            站内口碑 · 追更的人怎么说
          </h3>
          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {testimonialItems.map((item) => (
              <figure
                key={item.id}
                className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <div className="flex items-center gap-0.5 text-secondary-500">
                  {[0, 1, 2, 3, 4].map((star) => (
                    <i key={star} className="ri-star-fill text-sm" />
                  ))}
                </div>
                <blockquote className="mt-3 text-sm text-foreground-700 leading-relaxed flex-1">
                  {item.text}
                </blockquote>
                <figcaption className="mt-4 pt-4 border-t border-background-200">
                  <p className="text-sm font-medium text-foreground-900">{item.name}</p>
                  <p className="text-xs text-foreground-500">{item.role}</p>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}